import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-e7c23cd8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "content__container"
};
const _hoisted_3 = {
  class: "tree__container mg-b--15"
};
const _hoisted_4 = {
  class: "mg-l--25"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-ic_list"
}, null, -1));

const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  class: "table__container"
};
import { usePageConfig } from '@/utils/useComponentConfig';
import { useRoute, useRouter } from 'vue-router';
import { objToArr } from '@/utils/tools';
const __default__ = {
  name: 'FilmReview'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,

  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const isShowAside = ref(true);
    const TYPE_OPTION = {
      '0': '全部',
      '1': '单片',
      '2': '剧集'
    };
    const REVIEW_STATUS = {
      '0': '全部',
      '1': '终端审核',
      '2': '未审核',
      '3': '返回审核',
      '4': '未通过',
      '5': '已审核'
    };
    const Tags = computed(() => {
      let common = objToArr(REVIEW_STATUS, 'type', 'name');
      return isShowAside.value ? common : [{
        type: 'close',
        name: '',
        noActive: true,
        icon: 'icon-ic_list'
      }, ...common];
    }); // 处理点击事件

    const handleTagClick = tag => {
      if (tag.type === 'close') closeAside();
    };

    const searchConfig = reactive({
      formList: [{
        label: '关键字筛选',
        prop: 'keyWord',
        widgetType: 'input'
      }, {
        label: '语言',
        prop: 'lang',
        widgetType: 'Select'
      }, {
        label: '上线状态',
        prop: 'brand',
        widgetType: 'Select'
      }, {
        label: '审核状态',
        prop: 'brand',
        widgetType: 'Select'
      }, {
        label: '创建时间',
        prop: 'crateTime',
        widgetType: 'date'
      }, {
        label: '操作用户',
        prop: 'crateTime',
        widgetType: 'Select'
      }],
      formData: {
        brand: '',
        keyWord: '',
        attribute: '',
        lang: ''
      }
    });
    const tableConfig = reactive({
      data: [{
        fileName: '生活大爆炸第一季',
        type: 1,
        status: 2
      }, {
        fileName: '生活大爆炸第二季',
        type: 2,
        status: 3
      }],
      isCardBlock: true,
      paginationConfig: usePageConfig(),
      isShowHeader: false
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection'
      }, {
        label: '频道号',
        prop: 'fileName'
      }, {
        label: '频道名称',
        prop: 'type',
        formatter: value => TYPE_OPTION[value]
      }, {
        label: '别名',
        prop: 'codeProtocol'
      }, {
        label: '语言',
        prop: 'lang'
      }, {
        label: '审核状态',
        prop: 'status',
        formatter: value => REVIEW_STATUS[value]
      }, {
        label: '上线状态',
        prop: 'attribute'
      }, {
        label: '分类',
        prop: ''
      }, {
        label: '操作用户',
        prop: 'user'
      }, {
        label: '创建时间',
        prop: 'createTime'
      }]
    }); // 关闭侧边栏

    const closeAside = () => {
      isShowAside.value = !isShowAside.value;
    };

    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData
      }, null, 8, ["form-list", "form-data"]), _createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("div", _hoisted_3, [_createElementVNode("header", null, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('分类属性')), 1), _createElementVNode("span", {
        onClick: closeAside,
        class: "mg-r--25 aside__cursor"
      }, _hoisted_6)])], 512), [[_vShow, isShowAside.value]]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        "table-config": tableConfig
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config"])])])]);
    };
  }

});